<template>
  <header class="site-header">
    <div class="container">
      <div class="row">
        <div class="col-6 my-auto">
          <router-link to="/">
            <img src="@/assets/logo.svg" class="header-logo" alt />
          </router-link>
        </div>
        <div v-if="getUser" class="col-6 header-actions text-right">
          <b-dropdown class="header-menu" right no-caret>
            <template class="btn-primary" v-slot:button-content>
              <font-awesome-icon icon="bars" />
            </template>
            <router-link to="/profile" class="dropdown-item">
              My profile
            </router-link>
            <router-link to="/knowledgebase" class="dropdown-item">
              Knowledge base
            </router-link>
            <b-dropdown-divider></b-dropdown-divider>
            <li>
              <span @click="$signOut()" class="dropdown-item">Log out</span>
            </li>
            <li></li>
          </b-dropdown>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "AppHeader",
  components: {},
  computed: {
    ...mapState(["user"]),
    getUser() {
      return this.user ? this.user : "";
    },
  },
  data() {
    return {};
  },
  mounted: function() {},
  methods: {},
};
</script>
